'use client'
import { getVariantIdCookie, setVariantIdCookie } from './analytics'
import type { PlpSortConfigForClient } from './plp-sort-ab-testing'

/**
 * Ensures the PLP sort cookie is set on the client so future requests get consistent assignment.
 * Call this from a client component when plpSortConfig is provided.
 */
export function ensurePlpSortCookie(plpSortConfig?: PlpSortConfigForClient | null): void {
  if (!plpSortConfig?.cookieName || !plpSortConfig?.sortStrategy) return

  const existingCookie = getVariantIdCookie(plpSortConfig.cookieName)
  if (!existingCookie) {
    setVariantIdCookie(plpSortConfig.cookieName, plpSortConfig.sortStrategy)
  }
}
